module.exports = __webpack_public_path__ + "img/Vegetable-Lasagna-Horizontal-2.8a992bcc.jpg";